import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter, useRouteError, Outlet } from 'react-router-dom';
import { TitleProvider } from '@cocoan/components/Hooks'
import { Header, Toast } from 'react-frontier';
import { Login, PasswordComplete, Privacy } from './screens'
import { AuthProvider } from './AuthHooks';
import 'frontier-css/css/frontier.css';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

var ErrorElement = ()=>{
	const error = (useRouteError() as any);
	return <Header
		text={error.status}
		subtext={error.status===404 ? 'Página no encontrada' : `Hubo un error inesperado. (PBL-LCL-${error.status})`}
		style={{ fontSize: 100 }}
		subheaderStyle={{ fontSize: 20 }}
		containerStyle={{ marginTop: 20 }}
	/>
}

var SiteContainer = (props: { outlet: JSX.Element })=>{
	// return <TitleProvider suffix='COCOAN'>
	// 	<AuthProvider>
	// 		{props.outlet}
	// 	</AuthProvider>
	// </TitleProvider>
	return <AuthProvider>
		{props.outlet}
	</AuthProvider>
}

const Router = createBrowserRouter([{
	path: '/complete',
	errorElement: <SiteContainer outlet={<ErrorElement />} />,
	element: <SiteContainer outlet={<PasswordComplete />} />,
},{
	path: '/frame',
	errorElement: <SiteContainer outlet={<ErrorElement />} />,
	element: <SiteContainer outlet={<Login frame />} />,
},{
	path: '/privacy',
	errorElement: <SiteContainer outlet={<ErrorElement />} />,
	element: <SiteContainer outlet={<Privacy />} />,
},{
	path: '*',
	errorElement: <SiteContainer outlet={<ErrorElement />} />,
	element: <SiteContainer outlet={<Login />} />,
}]);

var Root = ()=>{
	return <Toast.Provider>
		<RouterProvider router={Router} />
	</Toast.Provider>
}

root.render(<Root />);